import"./Popover.css.tsx.vanilla.css";var r="_1l09l1k0";export{r as childrenPopover};
